import { useEffect, useRef, useState } from 'react';
import receptionService from '../services/receptionService';
import { formatReceptionHeaderMs } from '../components/receptionist/receptionFormatters';

/** Horloge en-tête synchronisée serveur (même rendu que le portail réception). */
export function useServerHeaderClock(enabled = true) {
  const [headerClock, setHeaderClock] = useState('Synchronisation…');
  const serverSkewMsRef = useRef(0);
  const serverDisplayTzRef = useRef('');

  useEffect(() => {
    if (!enabled) return undefined;

    let cancelled = false;

    async function sync() {
      try {
        const t0 = Date.now();
        const res = await receptionService.getServerTime();
        const t1 = Date.now();
        if (cancelled || !res.success || !res.data) return;
        const raw = res.data.unixMs;
        const serverMs = typeof raw === 'number' ? raw : parseInt(String(raw), 10);
        if (Number.isNaN(serverMs)) return;
        const rttHalf = Math.floor((t1 - t0) / 2);
        serverSkewMsRef.current = serverMs + rttHalf - Date.now();
        serverDisplayTzRef.current =
          typeof res.data.displayTimeZone === 'string' ? res.data.displayTimeZone.trim() : '';

        const nowAdjusted = Date.now() + serverSkewMsRef.current;
        setHeaderClock(formatReceptionHeaderMs(nowAdjusted, serverDisplayTzRef.current || undefined));
      } catch (e) {
        console.error(e);
        if (!cancelled) {
          setHeaderClock((prev) => (prev === 'Synchronisation…' ? 'Horloge indisponible' : prev));
        }
      }
    }

    sync();
    const syncInterval = window.setInterval(sync, 120000);
    const tickInterval = window.setInterval(() => {
      setHeaderClock(
        formatReceptionHeaderMs(
          Date.now() + serverSkewMsRef.current,
          serverDisplayTzRef.current || undefined
        )
      );
    }, 1000);

    return () => {
      cancelled = true;
      window.clearInterval(syncInterval);
      window.clearInterval(tickInterval);
    };
  }, [enabled]);

  return headerClock;
}
